import { LandingPageConfig } from 'rangeConfig/@types';
import brorBgImage from '../../views/LandingPage/images/bror_landing_bg.jpg';
import brorDesignFromScratch from '../../views/LandingPage/images/bror_design_from_scratch.png';
import brorBrowseInspirationImg from '../../views/LandingPage/images/bror_browse_inspiration.jpeg';
import brorGalleryConfig from './brorGalleryConfig';

const brorLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: brorBgImage,
    titleTextColor: '#FFFFFF'
  },
  designFromScratch: {
    backgroundColor: '#E6C6AF',
    backgroundImgUrl: brorDesignFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: brorBrowseInspirationImg
  },
  browseInspiration: {
    backgroundColor: '#E6C6AF',
    backgroundImgUrl: brorBrowseInspirationImg,
    galleryConfig: brorGalleryConfig
  }
};

export default brorLandingPageConfig;
